export default __webpack_public_path__ + "static/media/alert.02144a49.svg";